import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

import Coins from '@gef-ui/material-icons/Coins';

export const UrgencyTemplate = ({ icon, children }) => {
	const defaultIcon = <Coins sx={{ color: 'orange', cursor: 'default' }} />;

	return (
		<Stack
			direction="row"
			spacing={0.5}
			sx={{
				borderBottom: 1,
				borderBottomColor: 'grey.100',
				borderRadius: 1,
				minHeight: 50,
				py: 0.5,
				alignItems: 'center',
			}}
		>
			<IconButton disableRipple sx={{ cursor: 'default', ml: 1 }}>
				{icon || defaultIcon}
			</IconButton>
			{children}
		</Stack>
	);
};

UrgencyTemplate.propTypes = {
	children: PropTypes.any,
	icon: PropTypes.node,
};

export default UrgencyTemplate;
